import Section from '../ui/Section'
import { Display, Statement, Body, Points, Accent, Em } from '../ui/Type'

const GROWTH = ['More users.', 'More agents.', 'More reasoning.', 'More documents.', 'More context.', 'More automation.', 'More tokens.']

const COMPROMISES = [
  'They run workloads less often.',
  'Give agents less context.',
  'Limit concurrency.',
  'Use smaller models.',
  'Analyze less data.',
  'Stop experiments before they reach production.',
]

export default function Reframe() {
  return (
    <Section label="The real problem" tier="statement" divider={false}>
      <Display>
        Your AI isn't failing.
        <br />
        It's <Accent>being rationed.</Accent>
      </Display>

      <Body className="mt-8">Every time AI becomes more useful, consumption grows.</Body>
      <Points className="mt-8" cols={3} items={GROWTH} />

      <Body className="mt-14">
        Eventually the infrastructure underneath the intelligence starts determining what the business can afford to do.
      </Body>
      <Body className="mt-5">So teams compromise.</Body>
      <Points className="mt-8" cols={2} items={COMPROMISES} />

      <Statement className="mt-[5.5rem]">
        The technology isn't the limit.
        <br />
        The economics are.
      </Statement>
      <Body className="mt-8">
        <Em>Stop letting token consumption determine what your AI can accomplish.</Em>
      </Body>
    </Section>
  )
}
